import { ViewConfig } from "./types"

export function getDefaultViewConfig(config?: Partial<ViewConfig>) {

    return {

        croppingHeight: 65,

        fieldHeight: 25,

        leftOffset: 0,

        horizontalMargin: 10,
        bottomMargin: 150,

        durationScale: 1.5,
        durationScaleMin: 0.75,
        durationScaleMax: 1.5,

        ...config

    }

}
